import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { defineCustomElements as jeepSqlite} from 'jeep-sqlite/loader'; //added

import { defineCustomElements } from '@ionic/pwa-elements/loader'; //added

if (environment.production) {
  enableProdMode();
}

jeepSqlite(window); //added

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));

  // Call the element loader after the platform has been bootstrapped
defineCustomElements(window);